import { useContext } from 'react';
import { SidebarMenuCollapsibleContext } from '../SidebarMenuCollapsible/index.js';

var useSidebarMenuCollapsible = function useSidebarMenuCollapsible() {
  var context = useContext(SidebarMenuCollapsibleContext);
  if (!context) {
    throw new Error('useSidebarMenuCollapsible must be used as a child to <SidebarMenuCollapsible />');
  }
  return context;
};

export { useSidebarMenuCollapsible };
